<div class="container">
  <div class="box-form">
    <div class="content" *ngIf="!isError; else errorTemplate">
      <p class="header">TU APORTE FUE REALIZADO EXITOSAMENTE</p>
      <p class="note">
        El monto aportado se hará visible en tu póliza en un plazo máximo de 72
        horas hábiles a partir de la fecha de ingreso.
      </p>
      <p class="note">
        Este tiempo nos permite asegurarnos de que todos los procesos
        relacionados con su transacción se completen de manera segura y
        correcta.
      </p>
      <p class="note">
        Si tienes cualquier otra consulta, no dudes en contactarnos.
      </p>
      <p class="note"></p>
      <p class="note">
        Estamos disponibles en contactovida@security.cl donde un miembro de
        nuestro equipo estará listo para asistirte.
      </p>
    </div>
    <ng-template #errorTemplate>
      <div class="content">
        <p class="header">TU APORTE TUVO PROBLEMAS PARA SER REALIZADO</p>
        <p class="note">
          Favor reinténtelo más tarde o si necesitas ayuda contáctanos a nuestro
          correo contactovida@security.cl.
        </p>
      </div>
    </ng-template>
  </div>
</div>
